export default "__VITE_ASSET__DPJe5O_4__"